module.exports = __webpack_public_path__ + "static/design-debates-6867d636afdc24ee0ca2d1a51f8984ad.webm";